export const AddToCartReferType = {
  normal: 'normal',
  pantry: 'pantry',
  seller: 'seller',
  group: 'seller_group_order',
  addon: 'addon'
};

export const storageKeys = {
  traceId: 'trace_id'
};

export enum SpecialCategories {
  new = 'new',
  trending = 'trending',
  sale = 'sale'
}

export enum PageKey {
  categoty,
  search,
  cuisines
}

export enum ActionType {
  PdpMainAddCart
}

export enum PageName {
  page_product_details = 'page_product_details',
  page_product_details_related = 'page_product_details_related',
  page_product_details_buytogether = 'page_product_details_buytogether',
  page_collection = 'page_collection',
  page_cart = 'page_cart',
  page_checkout = 'page_checkout',
  page_order_confirm = 'page_order_confirm',
  page_search = 'page_search',
  page_category = 'page_category',
  page_address_edit = 'page_address_edit',
  page_login = 'page_account_login',
  page_signup = 'page_account_signup',
  page_me = 'page_me',
  page_home = 'page_home',
  page_onboarding = 'page_onboarding',
  page_referral = 'page_invite_friend',
  page_trade_in = 'page_trade_in',
  page_brand = 'page_brand',
  page_invite_friend_landing = 'page_invite_friend_landing',
  page_global_landing = 'page_global_landing',
  page_comm_home = 'mweb_comm_home',
  page_mkpl_waterfall = 'page_mkpl_waterfall',
  mweb_mkpl_lightning_deal = 'mweb_mkpl_lightning_deal'
}

export const route2PVEvent = {
  '/product/:slug/:id': PageName.page_product_details,
  '/promotion/collect/:id': PageName.page_collection,
  '/cart': PageName.page_cart,
  '/order/checkout': PageName.page_checkout,
  '/order/success/:id': PageName.page_order_confirm,
  '/search': PageName.page_search,
  '/category/:slug*': PageName.page_category,
  '/account/address/edit': PageName.page_address_edit,
  '/account/address/edit/:id': PageName.page_address_edit,
  '/account/login': PageName.page_login,
  '/account/signup': PageName.page_signup,
  '/account': PageName.page_me,
  '/': PageName.page_home,
  '/onboarding': PageName.page_onboarding,
  '/account/referral': PageName.page_referral,
  '/promotion/trade-in': PageName.page_trade_in,
  '/brand/:slug/:id': PageName.page_brand,
  '/account/referral/landing': PageName.page_invite_friend_landing,
  '/mkpl/global': PageName.page_global_landing,
  '/review': PageName.page_comm_home,
  '/mkpl/waterfall': PageName.page_mkpl_waterfall,
  '/mkpl/lightning-deals': PageName.mweb_mkpl_lightning_deal
};

export enum PageNameV2 {
  page_product_details = 'mweb_product',
  page_product_details_related = 'page_product_details_related',
  page_product_details_buytogether = 'page_product_details_buytogether',
  page_collection = 'page_collection',
  page_cart = 'page_cart',
  page_checkout = 'page_checkout',
  page_order_confirm = 'page_order_confirm',
  page_search = 'page_search',
  mweb_category = 'mweb_category',
  page_address_edit = 'page_address_edit',
  page_login = 'page_account_login',
  page_signup = 'page_account_signup',
  mweb_home = 'mweb_home',
  page_onboarding = 'page_onboarding',
  mweb_product = 'mweb_product',
  mweb_cuisine = 'mweb_cuisine',
  mweb_product_review = 'mweb_product_review',
  mweb_product_review_list = 'mweb_product_review_list',
  mweb_search_result = 'mweb_search_result',
  mweb_collection = 'mweb_collection',
  mweb_comm_home = 'mweb_comm_home',
  mweb_comm_video = 'mweb_comm_video',
  mweb_comm_event_list = 'mweb_comm_event_list',
  mweb_comm_event = 'mweb_comm_event',
  mweb_comm_hashtag_list = 'mweb_comm_hashtag_list',
  mweb_comm_hashtag = 'mweb_comm_hashtag',
  mweb_comm_search_result = 'mweb_comm_search_result',
  mweb_comm_profile = 'mweb_comm_profile',
  mweb_comm_profile_post = 'mweb_comm_profile_post',
  mweb_comm_profile_review = 'mweb_comm_profile_review',
  mweb_comm_profile_like = 'mweb_comm_profile_like',
  mweb_comm_profile_comment = 'mweb_comm_profile_comment',
  mweb_comm_profile_follower = 'mweb_comm_profile_follower',
  mweb_comm_profile_following = 'mweb_comm_profile_following',
  mweb_cart = 'mweb_cart',
  mweb_cart_selection = 'mweb_cart_selection',
  mweb_checkout_product_list = 'mweb_checkout_product_list',
  mweb_checkout = 'mweb_checkout',
  mweb_delivery_date_selection = 'mweb_delivery_date_selection',
  mweb_address = 'mweb_address',
  mweb_address_list = 'mweb_address_list',
  mweb_new_address = 'mweb_new_address',
  mweb_payment_method = 'mweb_payment_method',
  mweb_ebt_card_add = 'mweb_ebt_card_add',
  mweb_payment_new_card = 'mweb_payment_new_card',
  mweb_coupon = 'mweb_coupon',
  mweb_order_confirmation = 'mweb_order_confirmation',
  mweb_order_share_init = 'mweb_order_share_init',
  mweb_order_share_selection = 'mweb_order_share_selection',
  mweb_order_share_create = 'mweb_order_share_selection',
  mweb_order_share_succ = 'mweb_order_share_succ',
  mweb_me = 'mweb_me',
  mweb_me_profile = 'mweb_me_profile',
  mweb_me_profile_post = 'mweb_me_profile_post',
  mweb_me_profile_review = 'mweb_me_profile_review',
  mweb_me_profile_like = 'mweb_me_profile_like',
  mweb_me_profile_comment = 'mweb_me_profile_comment',
  mweb_me_profile_follower = 'mweb_me_profile_follower',
  mweb_me_profile_following = 'mweb_me_profile_following',
  mweb_me_my_order = 'mweb_me_my_order',
  mweb_me_my_list = 'mweb_me_my_list',
  mweb_order_modify = 'mweb_order_modify',
  mweb_order_detail = 'mweb_order_detail',
  mweb_me_vip = 'mweb_me_vip',
  mweb_me_weeebates = 'mweb_me_weeebates',
  mweb_me_points = 'mweb_me_points',
  mweb_referal = 'mweb_referal',
  mweb_recipo_referal = 'mweb_recipo_referal',
  mweb_me_coupon = 'mweb_me_coupon',
  mweb_me_help = 'mweb_me_help',
  mweb_me_setting = 'mweb_me_setting',
  mweb_me_update_password = 'mweb_me_update_password',
  mweb_me_about = 'mweb_me_about',
  mweb_me_lang = 'mweb_me_lang',
  mweb_me_message_center = 'mweb_me_message_center',
  mweb_me_message_inbox = 'mweb_me_message_inbox',
  mweb_login_signup = 'mweb_login_signup',
  mweb_onboarding = 'mweb_onboarding',
  mweb_store_selection = 'mweb_store_selection',
  mweb_onboarding_zip = 'mweb_onboarding_zip',
  mweb_welcome = 'mweb_welcome',
  mweb_me_review_select_product = 'mweb_me_review_select_product',
  mweb_me_review_edit = 'mweb_me_review_edit',
  mweb_me_review_details = 'mweb_me_review_details',
  mweb_me_review_list = 'mweb_me_review_list',
  mweb_before_you_checkout = 'mweb_before_you_checkout',
  mweb_event_landing = 'mweb_event_landing',
  mweb_raffle_landing = 'mweb_raffle_landing',
  mweb_lightning_deal = 'mweb_lightning_deal',
  mweb_trade_in = 'mweb_trade_in', //todo
  mweb_bundle = 'mweb_bundle', //todo
  mweb_referral = 'mweb_referal',
  mweb_me_my_bought = 'mweb_me_my_bought',
  mweb_me_my_watch_list = 'mweb_me_my_watchlist',
  mweb_me_my_reorder = 'mweb_me_my_reorder',
  mweb_me_my_recently = 'mweb_me_my_recently',
  mweb_search_landing = 'mweb_search_landing',
  mweb_member_purchase_sccess = 'mweb_member_purchase_sccess',
  mweb_member_share_list = 'mweb_member_share_list',
  mweb_points_group_buy = 'mweb_point_group_buy',
  mweb_points_groupbuy_list = 'mweb_points_groupbuy_list',
  mweb_points_groupbuy_landing = 'mweb_points_groupbuy_landing',
  mweb_points_groupbuy_progress = 'mweb_points_groupbuy_progress',
  mweb_points_groupbuy_order_success = 'mweb_points_groupbuy_order_success',
  mweb_support_rating = 'mweb_support_rating',
  mweb_about_cold_pack = 'mweb_cold_pack',
  mweb_pantry_intro = 'mweb_pantry_info',
  mweb_pantry_home = 'mweb_pantry_home',
  mweb_pantry_category = 'mweb_pantry_category',
  mweb_pantry_item = 'mweb_pantry_item',
  mweb_student_discount = 'mweb_student_discount',
  mweb_student_signup = 'mweb_student_signup',
  mweb_student_account_verify = 'mweb_student_account_verify',
  mweb_student_account_preverify = 'mweb_student_account_preverify',
  mweb_student_campaigns_landing = 'mweb_student_campaigns_landing',
  mweb_modify_order = 'mweb_modify_order',
  mweb_cancelled_order = 'mweb_cancelled_order',
  mweb_me_delete_account = 'mweb_me_delete_account',
  mweb_delete_account = 'mweb_delete_account',
  mweb_phone_connect = 'mweb_phone_connect',
  mweb_signup = 'mweb_signup',
  mweb_sort_filter = 'mweb_sort_filter',
  mweb_brand = 'mweb_brand',
  mweb_sayweee_collection = 'mweb_sayweee_collection',
  comm_curated_video = 'comm_curated_video',
  mweb_collection_targeted = 'mweb_collection_targeted',
  mweb_theme = 'mweb_theme',
  mweb_comm_curated_video = 'mweb_comm_curated_video',
  mweb_rtg_xsell_recommend = 'mweb_rtg_xsell_recommend',
  mweb_rtg_xsell_raffle = 'mweb_rtg_xsell_raffle',
  mweb_video_explore_more = 'mweb_video_explore_more',
  mweb_invite_friend_landing = 'mweb_invite_friend_landing',
  mweb_invite_friend_signup_success = 'mweb_invite_friend_signup_success',
  mweb_post_review = 'mweb_post_review',
  mweb_comm_user_insight_account = 'mweb_comm_user_insight_account',
  mweb_comm_user_insight_post = 'mweb_comm_user_insight_post',
  mweb_comm_user_tier = 'mweb_comm_user_tier',
  mweb_comm_earn_star_detail = 'mweb_comm_earn_star_detail',
  mweb_comm_earn_star_ways = 'mweb_comm_earn_star_ways',
  mweb_post_review_submit = 'mweb_post_review_submit',
  mweb_app_download = 'mweb_app_download',
  mweb_comm_guideline = 'mweb_comm_guideline',
  mweb_comm_guideline_feature = 'mweb_comm_guideline_feature',
  mweb_comm_guideline_review = 'mweb_comm_guideline_review',
  mweb_today_order = 'mweb_today_order',
  mweb_rtg_order_share = 'mweb_rtg_order_share',
  mweb_review_reminder = 'mweb_review_reminder',
  mweb_order_share_progress = 'mweb_order_share_progress',
  mweb_mkpl_vendor = 'mweb_mkpl_seller',
  mweb_fbw_vendor = 'mweb_fbw_seller',
  mweb_mkpl_vendor_detail = 'mweb_mkpl_seller_detail',
  mweb_global_intro = 'mweb_global_intro',
  mweb_global_faq = 'mweb_global_faq',
  mweb_grocery_order_share_landing = 'mweb_grocery_order_share_landing',
  mweb_order_share_view = 'mweb_order_share_view',
  mweb_order_share_signup = 'mweb_order_share_signup',
  mweb_me_message_center_community = 'mweb_me_message_center_community',
  mweb_me_message_center_order = 'mweb_me_message_center_order',
  mweb_me_message_center_cs = 'mweb_me_message_center_cs',
  mweb_me_message_center_system = 'mweb_me_message_center_system',
  mweb_me_message_center_promotions = 'mweb_me_message_center_promotions',
  mweb_me_message_center_rewards = 'mweb_me_message_center_rewards',
  mweb_rewards_dash = 'mweb_rewards_dash',
  mweb_rewards_landing = 'mweb_rewards_landing',
  mweb_checkout_dealpay = 'mweb_checkout_dealpay',
  mweb_login_account_verify = 'mweb_login_account_verify',
  mweb_mkpl_vendor_policy = 'mweb_mkpl_vendor_policy',
  mweb_mkpl_vendor_landing = 'mweb_mkpl_vendor_landing',
  mweb_mkpl_cart_promotion = 'mweb_mkpl_cart_promotion',
  mweb_mkpl_store_search_result = 'mweb_mkpl_store_search_result',
  mweb_mkpl_store_search_landing = 'mweb_mkpl_store_search_landing',
  mweb_point_welfare_buy = 'mweb_point_welfare_buy',
  mweb_nocart_checkout = 'mweb_nocart_checkout',
  mweb_gift_card_checkout = 'mweb_gift_card_checkout',
  mweb_mkpl_group_order_landing = 'mweb_mkpl_group_order_landing',
  mweb_group_order_product = 'mweb_group_order_product',
  mweb_group_order_list_host = 'mweb_group_order_list_host',
  mweb_group_order_list_guest = 'mweb_group_order_list_guest',
  mweb_mkpl_group_order_intro = 'mweb_mkpl_group_order_intro',
  mweb_mkpl_global_search_landing = 'mweb_mkpl_global_search_landing',
  mweb_mkpl_global_search_result = 'mweb_mkpl_global_search_result',
  mweb_mkpl_waterfall = 'mweb_mkpl_waterfall',
  mweb_mkpl_lightning_deal = 'mweb_mkpl_lightning_deal',
  mweb_mkpl_raffle = 'mweb_mkpl_raffle',
  mweb_mkpl_top_items = 'mweb_mkpl_top_items',
  mweb_cms_page = 'mweb_cms_page',
  mweb_loyalty_rewards_landing = 'mweb_loyalty_rewards_landing',
  mweb_thursday_lower_minimum_landing = 'mweb_thursday_lower_minimum_landing',
  mweb_student_no_minimum_landing = 'mweb_student_no_minimum_landing',
  mweb_topx_list = 'mweb_topx_list',
  mweb_topx_chart_list = 'mweb_topx_chart_list',
  mweb_mkpl_minicart = 'mweb_mkpl_minicart',
  mweb_affiliate_portal = 'mweb_affiliate_portal',
  mweb_comm_topic_detail = 'mweb_comm_topic_detail',
  mweb_comm_editor_pick = 'mweb_comm_editor_pick',
  mweb_share_list_landing = 'mweb_share_list_landing',
  mweb_share_list_detail = 'mweb_share_list_detail',
  mweb_share_list_new = 'mweb_share_list_new',
  mweb_mkpl_coupon_landing = 'mweb_mkpl_coupon_landing',
  mweb_mkpl_coupon_detail = 'mweb_mkpl_coupon',
  mweb_set_pwd = 'mweb_set_pwd',
  mweb_brand_landing = 'mweb_brand_landing',
  mweb_onboarding_check_email = 'mweb_onboarding_check_email',
  mweb_onboarding_enter_code = 'mweb_onboarding_enter_code',
  mweb_freebie_main_page = 'mweb_freebie_main_page',
  mweb_freebie_me_page = 'mweb_freebie_me_page',
  mweb_product_favor = 'mweb_product_favor',
  mweb_affiliate_signup = 'mweb_affiliate_signup',
  mweb_affiliate_signup_terms = 'mweb_affiliate_signup_terms',
  mweb_affiliate_signup_form = 'mweb_affiliate_signup_form',
  mweb_affiliate_share_tutorial = 'mweb_affiliate_share_tutorial',
  mweb_promotion_recommend = 'mweb_promotion_recommend',
  mweb_promotion_shop_deal = 'mweb_trade_in',
  mweb_affiliate_share_list = 'mweb_affiliate_share_list',
  mweb_affiliate_share_list_detail = 'mweb_affiliate_share_list_detail',
  mweb_bakery_landing = 'mweb_bakery_landing',
  mweb_help_view = 'mweb_help_view',
  mweb_help_search = 'mweb_help_search',
  mweb_category_simplified = 'mweb_category_simplified',
  mweb_search_result_simplified = 'mweb_search_result_simplified',
  mweb_grocery_minicart = 'mweb_grocery_minicart',
  mweb_product_simplified = 'mweb_product_simplified',
  mweb_product_review_simplified = 'mweb_product_review_simplified',
  mweb_freshdeli_landing = 'mweb_freshdeli_landing',
  mweb_help_detail = 'mweb_help_detail',
  mweb_gold_rewards_lading = 'mweb_activity',
  mweb_promotion_landing = 'mweb_promotion_landing',
  mweb_change_date_list = 'mweb_change_date_list',
  mweb_change_date_detail = 'mweb_change_date_detail',
  mweb_gift_card_landing = 'mweb_gift_card_landing',
  mweb_gift_card_redeem = 'mweb_gift_card_redeem',
  gift_card_order_confirmation = 'gift_card_order_confirmation',
  mweb_coupon_landing = 'mweb_coupon_landing',
  mweb_annual_report = 'mweb_annual_report',
  mweb_annual_report_2025 = 'mweb_annual_report_2025',
  mweb_guaranteed_delivery = 'mweb_guaranteed_delivery',
  mweb_camapgins_lty_hok = 'mweb_hok_raffle_2025',
  mweb_order_review = 'mweb_order_review',
  mweb_rating_submitted = 'mweb_rating_submitted',
  mweb_student_benefits = 'mweb_student_hub',
  mweb_subscribe_list = 'mweb_subscribe_list',
  mweb_subscribe_detail = 'mweb_subscribe_detail',
  mweb_oos_replace = 'mweb_oos_replace'
}

export const route2PVEventV2 = {
  '/': PageNameV2.mweb_home,
  '/category/:slug*': PageNameV2.mweb_category,
  '/mkpl/category/:slug*': PageNameV2.mweb_category,
  '/product/:slug/:id': PageNameV2.mweb_product,
  '/cuisines': PageNameV2.mweb_cuisine,
  '/promotion/collect/:id': PageNameV2.mweb_collection,
  '/review/more/:id': PageNameV2.mweb_product_review_list,
  '/social/review/more/:id': PageNameV2.mweb_product_review_list,
  '/search': PageNameV2.mweb_search_result,
  '/promotion/collect': PageNameV2.mweb_collection,
  '/promotion/lightning-deals': PageNameV2.mweb_lightning_deal,
  '/review': PageNameV2.mweb_comm_home,
  '/social': PageNameV2.mweb_comm_home,
  '/social/video/:id': PageNameV2.mweb_comm_video,
  '/social/event/list': PageNameV2.mweb_comm_event_list,
  '/social/event/detail/:id': PageNameV2.mweb_comm_event,
  '/review/channel/:id': PageNameV2.mweb_comm_event,
  '/social/promotion/buyer-rec-videos': PageNameV2.mweb_comm_curated_video,
  '/review/promotion/pdp-post-explore-more': PageNameV2.mweb_video_explore_more,
  '/social/promotion/pdp-post-explore-more/:id': PageNameV2.mweb_video_explore_more,
  '/review/search': PageNameV2.mweb_comm_search_result,
  '/social/search': PageNameV2.mweb_comm_search_result,
  '/social/hashtag/list': PageNameV2.mweb_comm_hashtag_list,
  '/social/hashtag/detail/:id': PageNameV2.mweb_comm_hashtag,
  '/review/download': PageNameV2.mweb_app_download,
  '/social/guidelines/feature': PageNameV2.mweb_comm_guideline_feature,
  '/social/guidelines': PageNameV2.mweb_comm_guideline,
  '/review/post-review/review-product': PageNameV2.mweb_post_review,
  '/social/post-review/review-product': PageNameV2.mweb_post_review,
  '/review/post-review/edit-review': PageNameV2.mweb_me_review_edit,
  '/social/post-review/edit-review': PageNameV2.mweb_me_review_edit,
  '/social/guidelines/post-review': PageNameV2.mweb_comm_guideline_review,
  '/social/review/:id': PageNameV2.mweb_product_review,
  '/social/user/:id/profile': PageNameV2.mweb_comm_profile,
  '/review/user/insight/account/:id': PageNameV2.mweb_comm_user_insight_account,
  '/review/user/insight/post/:id': PageNameV2.mweb_comm_user_insight_post,
  '/social/user/tier': PageNameV2.mweb_comm_user_tier,
  '/social/user/tier/star-earnings-details': PageNameV2.mweb_comm_earn_star_detail,
  '/social/user/tier/ways-to-earn-stars': PageNameV2.mweb_comm_earn_star_ways,
  '/social/user/:id/account-insight': PageNameV2.mweb_comm_user_insight_account,
  '/social/user/:id/post-insight': PageNameV2.mweb_comm_user_insight_post,
  '/review/post-review/review-submitted': PageNameV2.mweb_post_review_submit,
  '/social/post-review/review-submitted': PageNameV2.mweb_post_review_submit,
  '/cart': PageNameV2.mweb_cart,
  '/cart/selection': PageNameV2.mweb_cart_selection,
  '/order/checkout': PageNameV2.mweb_checkout,
  '/order/checkout/v1': PageNameV2.mweb_checkout,
  '/delivery-date-selection': PageNameV2.mweb_delivery_date_selection, //todo 这个是弹窗, 埋点不一样
  '/address/edit': PageNameV2.mweb_address,
  '/address/new': PageNameV2.mweb_new_address, //todo 现在新增也是和 edit 一样的
  '/account/address': PageNameV2.mweb_address,
  '/account/settings/payment-method': PageNameV2.mweb_payment_method, //todo 这个是弹窗, 埋点不一样
  // '/account/settings/payment-method': PageNameV2.mweb_ebt_card_add, //todo 这个是弹窗, 埋点不一样
  '/account/settings/payment-add-card': PageNameV2.mweb_payment_new_card, //todo 这个是弹窗, 埋点不一样
  '/account/my-coupons': PageNameV2.mweb_me_coupon,
  '/order/success/:id': PageNameV2.mweb_order_confirmation,
  '/order/success/v2/:id': PageNameV2.mweb_order_confirmation,
  '/order_share/create/:id': PageNameV2.mweb_order_share_selection,
  '/order/share/grocery/create/:id': PageNameV2.mweb_order_share_create,
  '/account': PageNameV2.mweb_me,
  '/account/profile/:id': PageNameV2.mweb_me_profile,
  '/order/list': PageNameV2.mweb_me_my_order,
  '/order_modify': PageNameV2.mweb_order_modify,
  '/order/detail/:id': PageNameV2.mweb_order_detail,
  '/order/share/list': PageNameV2.mweb_me_weeebates,
  '/invite_friends/share': PageNameV2.mweb_referal,
  '/invite_friends/ricepo_share': PageNameV2.mweb_recipo_referal,
  '/account/help': PageNameV2.mweb_me_help,
  '/account/settings': PageNameV2.mweb_me_setting,
  '/me/update_password': PageNameV2.mweb_me_update_password,
  '/about/us': PageNameV2.mweb_me_about,
  '/account/setting-language': PageNameV2.mweb_me_lang,
  '/message': PageNameV2.mweb_me_message_center,
  '/message/chat': PageNameV2.mweb_me_message_inbox,
  '/account/login': PageNameV2.mweb_login_signup,
  '/onboarding': PageNameV2.mweb_onboarding,
  '/welcome': PageNameV2.mweb_welcome,
  '/post/my_products': PageNameV2.mweb_me_review_select_product,
  '/post/create': PageNameV2.mweb_me_review_edit,
  '/post/view/:id': PageNameV2.mweb_me_review_details,
  '/post/my_posts': PageNameV2.mweb_me_review_list,
  '/activity/:id': PageNameV2.mweb_event_landing,
  '/activity/raffle/landing': PageNameV2.mweb_raffle_landing,
  '/account/referral': PageNameV2.mweb_referral,
  '/promotion/trade-in': PageNameV2.mweb_trade_in,
  '/account/member/purchase-success/:id': PageNameV2.mweb_member_purchase_sccess,
  '/account/member/share-list': PageNameV2.mweb_member_share_list,
  '/about/cold-pack': PageNameV2.mweb_about_cold_pack,
  '/account/points/group-buy': PageNameV2.mweb_points_group_buy,
  '/account/points/group-buy/list': PageNameV2.mweb_points_groupbuy_list,
  '/account/points/group-buy/landing/:id': PageNameV2.mweb_points_groupbuy_landing,
  '/account/points/group-buy/progress/:id': PageNameV2.mweb_points_groupbuy_progress,
  '/account/points/group-buy/order-success/:id': PageNameV2.mweb_points_groupbuy_order_success,
  '/student-discount': PageNameV2.mweb_student_discount,
  '/student-discount/email-signup': PageNameV2.mweb_student_signup,
  '/student-discount/email-send': PageNameV2.mweb_student_account_preverify,
  '/student-discount/code-verify': PageNameV2.mweb_student_account_verify,
  '/student-campaign/:id': PageNameV2.mweb_student_campaigns_landing,
  '/pantry/intro': PageNameV2.mweb_pantry_intro,
  '/support/rating': PageNameV2.mweb_support_rating,
  '/account/settings/delete-account': PageNameV2.mweb_me_delete_account,
  '/account/delete-account': PageNameV2.mweb_delete_account,
  '/account/phone-connect': PageNameV2.mweb_phone_connect,
  '/account/signup': PageNameV2.mweb_login_signup,
  '/promotion/collection/0sgU6hcb': PageNameV2.mweb_collection_targeted,
  '/promotion/collection/:interest': PageNameV2.mweb_sayweee_collection,
  '/promotion/theme_landing': PageNameV2.mweb_theme,
  '/account/address/edit': PageNameV2.mweb_new_address,
  '/account/address/edit/:id': PageNameV2.mweb_new_address,
  '/brand/:slug/:id': PageNameV2.mweb_brand,
  '/brand/detail/:slug/:id': PageNameV2.mweb_brand,
  '/account/referral/landing': PageNameV2.mweb_invite_friend_landing,
  '/account/referral/success': PageNameV2.mweb_invite_friend_signup_success,
  '/order/activity/coupon': PageNameV2.mweb_rtg_xsell_raffle,
  '/order/today-order': PageNameV2.mweb_today_order,
  '/order/share/rtg/landing/:id': PageNameV2.mweb_rtg_order_share,
  '/support/review-reminder': PageNameV2.mweb_review_reminder,
  '/order/share/grocery/view/:id': PageNameV2.mweb_order_share_progress,
  '/mkpl/global': PageNameV2.mweb_mkpl_vendor_landing,
  '/weeebates/share/grocery/landing/:id': PageNameV2.mweb_grocery_order_share_landing,
  '/order/share/grocery/follow-buy/:id': PageNameV2.mweb_order_share_view,
  '/order/share/grocery/sign-up': PageNameV2.mweb_order_share_signup,
  '/account/notification': PageNameV2.mweb_me_message_center,
  '/account/notification/community': PageNameV2.mweb_me_message_center_community,
  '/account/notification/order': PageNameV2.mweb_me_message_center_order,
  '/account/notification/rewards': PageNameV2.mweb_me_message_center_rewards,
  '/account/notification/system': PageNameV2.mweb_me_message_center_system,
  '/account/notification/cs': PageNameV2.mweb_me_message_center_cs,
  '/account/notification/promotions': PageNameV2.mweb_me_message_center_promotions,
  '/account/rewards/level': PageNameV2.mweb_rewards_dash,
  '/account/rewards/landing': PageNameV2.mweb_rewards_landing,
  '/order/dealpay/v2/:id': PageNameV2.mweb_checkout_dealpay,
  '/order/dealpay/:id': PageNameV2.mweb_checkout_dealpay,
  '/account/verify': PageNameV2.mweb_login_account_verify,
  '/mkpl/search': PageNameV2.mweb_mkpl_store_search_result,
  '/mkpl/vendor/:id': PageNameV2.mweb_mkpl_vendor,
  '/mkpl/vendor/detail/:id': PageNameV2.mweb_mkpl_vendor_detail,
  '/promotion/combine-purchase': PageNameV2.mweb_mkpl_cart_promotion,
  '/account/points/welfare-buy': PageNameV2.mweb_point_welfare_buy,
  '/order/nocart-checkout': PageNameV2.mweb_nocart_checkout,
  '/order/nocart-checkout/gift': PageNameV2.mweb_gift_card_checkout,
  '/order/gift-card/success/:id': PageNameV2.gift_card_order_confirmation,
  '/mkpl/group-order/landing': PageNameV2.mweb_mkpl_group_order_landing,
  '/mkpl/group-order/product/:slug/:id': PageNameV2.mweb_group_order_product,
  '/mkpl/group-order/list-host': PageNameV2.mweb_group_order_list_host,
  '/mkpl/group-order/list-guest': PageNameV2.mweb_group_order_list_guest,
  '/mkpl/introducing-group-order': PageNameV2.mweb_mkpl_group_order_intro,
  '/mkpl/waterfall': PageNameV2.mweb_mkpl_waterfall,
  '/mkpl/lightning-deals': PageNameV2.mweb_mkpl_lightning_deal,
  '/mkpl/anniversary/:id': PageNameV2.mweb_mkpl_raffle,
  '/mkpl/christmas/:id': PageNameV2.mweb_mkpl_raffle,
  '/cms/page/:type/:key': PageNameV2.mweb_cms_page,
  '/promotion/rewards-landing': PageNameV2.mweb_loyalty_rewards_landing,
  '/promotion/rewards-landing/thursday': PageNameV2.mweb_thursday_lower_minimum_landing,
  '/promotion/rewards-landing/student': PageNameV2.mweb_student_no_minimum_landing,
  '/promotion/top-x/chart': PageNameV2.mweb_topx_chart_list,
  '/promotion/top-x/:key': PageNameV2.mweb_topx_list,
  '/topics/:id/collection': PageNameV2.mweb_comm_editor_pick,
  '/topics/:id': PageNameV2.mweb_comm_topic_detail,
  '/share/list/:id': PageNameV2.mweb_share_list_landing,
  '/account/my-list/book/:id': PageNameV2.mweb_share_list_detail,
  '/account/my-list/new': PageNameV2.mweb_share_list_new,
  '/mkpl/coupon/landing': PageNameV2.mweb_mkpl_coupon_landing,
  '/mkpl/coupon/:plan_id': PageNameV2.mweb_mkpl_coupon_detail,
  '/mkpl/bakery/landing': PageNameV2.mweb_bakery_landing,
  '/mkpl/freshdeli/landing': PageNameV2.mweb_freshdeli_landing,
  '/mkpl/top-items': PageNameV2.mweb_mkpl_top_items,
  '/account/onboarding/login-with-password': PageNameV2.mweb_set_pwd,
  '/brand/landing': PageNameV2.mweb_brand_landing,
  '/account/affiliate': PageNameV2.mweb_affiliate_portal,
  '/account/affiliate/landing': PageNameV2.mweb_affiliate_signup,
  '/account/affiliate/apply': PageNameV2.mweb_affiliate_signup_terms,
  '/account/affiliate/apply/form': PageNameV2.mweb_affiliate_signup_form,
  '/account/affiliate-list': PageNameV2.mweb_affiliate_share_list,
  '/account/affiliate-list/:id': PageNameV2.mweb_affiliate_share_list_detail,
  '/account/check-email': PageNameV2.mweb_onboarding_check_email,
  '/account/onboarding/phone-verify': PageNameV2.mweb_onboarding_enter_code,
  '/freebie/landing': PageNameV2.mweb_freebie_main_page,
  '/freebie/list': PageNameV2.mweb_freebie_me_page,
  '/product-favorite': PageNameV2.mweb_product_favor,
  '/help/view/:key': PageNameV2.mweb_help_view,
  '/help/search': PageNameV2.mweb_help_search,
  '/add-on/landing': PageNameV2.mweb_category_simplified,
  '/add-on/search': PageNameV2.mweb_search_result_simplified,
  '/promotion/recommend': PageNameV2.mweb_promotion_recommend,
  '/promotion/shop-deal': PageNameV2.mweb_promotion_shop_deal,
  '/help/detail/:key': PageNameV2.mweb_help_detail,
  '/rewards/gold-rewards/landing': PageNameV2.mweb_gold_rewards_lading,
  '/rewards/gold-rewards/app-popup': PageNameV2.mweb_gold_rewards_lading,
  '/promotion/free-gift/landing': PageNameV2.mweb_promotion_landing,
  '/support/trade-in-pop': PageNameV2.mweb_category,
  '/order/change-date/list': PageNameV2.mweb_change_date_list,
  '/order/change-date/detail/:id': PageNameV2.mweb_change_date_detail,
  '/account/gift-card/landing': PageNameV2.mweb_gift_card_landing,
  '/account/gift-card/redeem': PageNameV2.mweb_gift_card_redeem,
  '/promotion/coupon-landing': PageNameV2.mweb_coupon_landing,
  '/annual-report/2024': PageNameV2.mweb_annual_report,
  '/annual-report/2025': PageNameV2.mweb_annual_report_2025,
  '/promotion/deliver-by-five': PageNameV2.mweb_guaranteed_delivery,
  '/campaigns/lty/hok-partnership-2025': PageNameV2.mweb_camapgins_lty_hok,
  '/social/post-review/review-order/:id': PageNameV2.mweb_order_review,
  '/social/post-review/home-popup/:id': PageNameV2.mweb_support_rating,
  '/social/post-review/result/:id': PageNameV2.mweb_rating_submitted,
  '/student-benefits': PageNameV2.mweb_student_benefits,
  '/subscribe/list': PageNameV2.mweb_subscribe_list,
  '/subscribe/detail': PageNameV2.mweb_subscribe_detail,
  '/pantry': PageNameV2.mweb_pantry_home,
  '/shopping_list': PageNameV2.mweb_pantry_category,
  // '/goods/catalog/:item' 不写死在这里，让 SDK 因匹配不到而调用 getPageKey(url)，与 vendor 一致拿到动态 mweb_pantry_item_${item}
  '/similar-items': PageNameV2.mweb_oos_replace
};

/**
 * 活动中心key的映射
 * 活动页接口返回的key和埋点所需key不一致时，需要在这里映射下
 */
export const ActivityContentKeyMapping = {
  gold_rewards: 'rewards_membership_update'
};

export const TrackTypes = {
  searchProductCart: 'searchProductCart',
  checkoutUpsellProductCardView: 'checkoutUpsellProductCardView'
};

export const BusEventKeys = {
  productCardInViewPort: 'bus_product_card_in_viewport',
  productCardImpression: 'bus_product_card_impression',
  productCardToView: 'bus_product_card_to_view',
  productCardAddToCartInPDPSimilar: 'bus_product_card_add_to_cart_in_pdp_similar',
  productCardAddToCartInPDPRelated: 'bus_product_card_add_to_cart_in_pdp_related',
  productCardClick: 'bus_product_card_click',
  postListImpression: 'post_list_impression',
  productCardAddToCartInTrending: 'bus_product_card_add_to_cart_in_trending'
};

export const HashtagEventType = {
  postVideoConsumption: 'post_video_consumption' // post卡片点击埋点
};

export const CommunityHomeEventType = {
  postListClick: 'post_list_click'
};
export const CommunityHomeClickType = {
  postListEventCard: 'post_list_event_card',
  postListEventSeeAll: 'post_list_event_see_all',
  postListEventMore: 'post_list_event_more',
  postListHashtag: 'post_list_hashtag',
  postListHashtagMore: 'post_list_hashtag_more',
  postListHashtagSeeAll: 'post_list_hashtag_see_all'
};

export const DiscountType = {
  sale: 'sale',
  lightning: 'lightning'
};

export const SearchTriggerType = {
  active: 'search_active', // 用户点击回车/search按钮
  suggestion: 'search_suggestion', // 用户输入部分内容后点击系统推荐的搜索词
  history: 'search_history', // 用户点击历史搜索词
  popular: 'search_popular', // 用户点击热门搜索
  tagpdp: 'tag_pdp', // 用户通过PDP里的商品标签进入结果页
  sorting: 'pc_sorting', // PC端用户点击某个排序
  taxonomy: 'taxonomy', // 点击某个category/subcategory记录{category}-{subcategory}
  filter: 'filter' // 用户点击左侧的过滤器
};

export const NewTracking = {
  pageView: 'page_view',
  bannerImp: 't2_banner_imp',
  ellipseImp: 't2_ellipse_imp',
  filterImp: 't2_filter_button_imp',
  productImp: 't2_prod_imp',
  cartAction: 't2_cart_action',
  clickAction: 't2_click_action',
  cartImp: 't2_cart_imp',
  pageSectionImp: 't2_page_sec_imp',
  upsellListImpression: 'upsell_list_impression',
  popup: 't2_popup'
};

export const BannerType = {
  homeMainBanner: 'home_top_banner',
  homeMessage: 'message',
  homeVideoBanner: 'video',
  homeThemeBanner: 'theme',
  homeBannerLine: 'banner_line',
  commHomeEventBanner: 'social_event',
  commHomeTrendingBanner: 'social_trending',
  pdpReview: 'review',
  pdpBanner: 'banner_line',
  homeTopicBanner: 'topic',
  featuredSku: 'featured_sku'
};

export const EllipseType = {
  category: 'category',
  cuisine: 'cuisine'
};

export const CategoryMod = {
  ellipse: 'ellipse_carousel',
  filterBtn: 'filter_buttons',
  itemList: 'item_list'
};

export const SortFilterMod = {
  sort: 'sort',
  filter: 'filter'
};

export const SearchMod = {
  searchTypeTab: 'search_type_tabs',
  filterBtn: 'filter_buttons',
  itemList: 'item_list'
};

export const PdpMod = {
  detail: 'product_detail',
  banner: 'banner_line',
  review: 'reviews_carousel',
  video: 'video_carousel',
  related: 'related',
  buytogether: 'buytogether',
  vendor: 'same_vendor_item',
  groupOrder: 'group_order',
  featuredSku: 'featured_sku'
};

export const BogoMod = {
  filterBtn: 'filter_buttons',
  itemList: 'item_list'
};
export const TradeInMod = {
  itemList: 'item_list',
  tradeIn: 'trade_in'
};
export const RtgModName = {
  waveSelection: 'wave_selection',
  rtgTopBanner: 'rtg_top_banner',
  ellipseCarousel: 'ellipse_carousel',
  filterButtons: 'filter_buttons',
  allVendors: 'all_vendors',
  rtgVendor: 'rtg_vendor',
  itemList: 'item_list',
  itemDetails: 'item_details',
  reviewCarousel: 'review_carousel',
  rtgCartPopup: 'rtg_cart_popup',
  rtgSearch: 'rtg_search'
};
export const CartMod = {
  cart: 'cart',
  invalidItemList: 'invalid_items_list',
  recommendItemList: 'recommend_item_list',
  mkplCartItem: 'mkpl_cart_item',
  mkplCartRecommend: 'mkpl_cart_recommend'
};

export const CommunityVideoDetailsMod = {
  itemList: 'item_list',
  comments: 'comments',
  videoCarousel: 'video_carousel'
};

export const status2OosMap = {
  sold_out: 2,
  change_other_day: 1
};

export const MyListMod = {
  filterBtn: 'filter_buttons',
  itemList: 'item_list'
};
export const CheckoutUpsellMod = {
  complete: 'checkout_complete',
  sale: 'checkout_sale',
  preference: 'checkout_preference'
};

export const ClickTargetType = {
  normalBtn: 'normal_button',
  product: 'product',
  section: 'section',
  filterBtn: 'filter_button',
  sortFilter: 'sort_filter',
  applyBtn: 'apply_button',
  searchTarget: 'search_target',
  shareButton: 'share_button',
  shareChannel: 'share_channel',
  collection: 'collection',
  referral: 'referral_portal'
};

export const ClickType = {
  view: 'view',
  liked: 'liked',
  save: 'save',
  unsave: 'unsave',
  share: 'share',
  normal: 'normal',
  like: 'like',
  unlike: 'unlike',
  comment: 'comment',
  follow: 'follow',
  unfollow: 'unfollow',
  review: 'review'
};

export const SearchLandingMod = {
  searchBar: 'search_bar',
  searchHistory: 'search_history',
  popularSearch: 'popular_search',
  boughtBefore: 'bought_before'
};

export const ThemeMod = {
  filterBtn: 'filter_buttons',
  itemList: 'item_list'
};

export const OrderListMod = {
  filterBtn: 'filter_buttons'
};

export const BrandMod = {
  filterBtn: 'filter_buttons',
  itemList: 'item_list'
};

export const CommonMod = {
  filterBtn: 'filter_buttons',
  itemList: 'item_list'
};

export type ADsTrackingDataType = {
  trackViewUrl?: string;
  trackRedirectUrl?: string;
  trackClickUrl?: string;
  trackAddToCartUrl?: string;
  [key: string]: any;
};
